<template src="./MaincategoryYear.html"></template>

<script>
import axios from 'axios'

const c3 = require('c3')

import Back from '@/components/Dashboard/Back'
import Searchfield from '@/components/Dashboard/Searchfield'
import Settings from '@/components/Dashboard/Settings'
import Years from '@/components/Dashboard/Years'

export default {
  name: 'maincategoryYear',
  components: { Back, Searchfield, Settings, Years },
  data () {
    return {
      years: this.$parent.years,
      year: '',
      categories: [],
      tmpCategories: [],
      showmore: false,
      sort: 'revenues',
      searchword: '',
      mode: '1',
      sum: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    }
  },
  mounted: function() {
    this.year = this.$route.params.year

    this.fetchData()
  },
  watch: {
    mode: function() {
      this.$nextTick(function() {
        this.fetchData()
      })
    }
  },
  methods: {
    dateRedirect: function() {
      this.$router.push('/dashboard/statistics/maincategories/' + this.year)
      this.fetchData()
    },
    reduceList: function(searchword) {
      if(this.tmpCategories.length==0) {
        this.tmpCategories = this.categories
      }

      if(searchword!="") {

        this.categories = this.categories.filter(function(cat) {        
          return cat.name.toLowerCase().indexOf( searchword.toLowerCase())>=0
        })

      } else {

        this.categories = this.tmpCategories

      }
    },
    fetchData: function() {
      this.$parent.loader = 1
      var url = this.$serviceurl + 'statistik/umsatz/hatg/kunde/' + localStorage.getItem('ext-kunde');
      let headers = { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'app-version': '2.2', 'token' : localStorage.getItem('ext-token') };
      let options = { headers: headers };
      
      axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year + '&periode=' + this.period, options).then(response => {
        this.categories = response.data
        if(this.modus=='top') {
          this.categories = this._.orderBy(this.categories, ['umsatzLj'], ['desc']);
        }
        if(this.modus=='flop') {
          this.categories = this._.orderBy(this.categories, ['umsatzLj'], ['asc']);
        }
        this.drawChart()
        this.$parent.loader = 0
        if(this.searchword!="") this.reduceList(this.searchword)
      })
      .catch(e => {
        //console.log(e)
      })
    },
    drawChart: function() {
      var tmpCat = this.categories

      if(this.mode!='1') {
        this.categories = this._.orderBy(this.categories,['erloesLj'],['desc'])
      } else {
        this.categories = tmpCat
      }

      var dataLj = [
        [],
        [],
        [],
        [],
        [],
        []
      ];

      var columnsArr = [];

      var showChart = false

      for (var index = 0; index < this.categories.length; index++) {
        if(index<5) {
          if(this.mode=='1') {
            columnsArr.push([this.categories[index].name, this.categories[index].umsatzLj]);
          }else{
            columnsArr.push([this.categories[index].name, this.categories[index].umsatzLj]);
          }    
          if(this.categories[index].umsatzLj > 0) {
            showChart = true
          }
          dataLj[0].push(this.categories[index].id);
          dataLj[1].push(this.categories[index].name);
          dataLj[2].push(this.categories[index].umsatzLj);
          dataLj[3].push(this.categories[index].umsatzVj);
          dataLj[4].push(this.categories[index].erloesLj);
          dataLj[5].push(this.categories[index].erloesVj);
        }
      }

      //console.log(columnsArr);

      /*
      var dataLj = [
        [
          this.categories[0].id,
          this.categories[1].id,
          this.categories[2].id,
          this.categories[3].id, 
          this.categories[4].id,
        ],
        [
          this.categories[0].name,
          this.categories[1].name,
          this.categories[2].name,
          this.categories[3].name, 
          this.categories[4].name,
        ],
        [
          this.categories[0].umsatzLj,
          this.categories[1].umsatzLj,
          this.categories[2].umsatzLj,
          this.categories[3].umsatzLj, 
          this.categories[4].umsatzLj,
        ],
        [
          this.categories[0].umsatzVj,
          this.categories[1].umsatzVj,
          this.categories[2].umsatzVj,
          this.categories[3].umsatzVj, 
          this.categories[4].umsatzVj,
        ],
        [
          this.categories[0].erloesLj,
          this.categories[1].erloesLj,
          this.categories[2].erloesLj,
          this.categories[3].erloesLj, 
          this.categories[4].erloesLj,
        ],
        [
          this.categories[0].erloesVj,
          this.categories[1].erloesVj,
          this.categories[2].erloesVj,
          this.categories[3].erloesVj, 
          this.categories[4].erloesVj,
        ]
      ];
      */

      /*if(this.mode=='1') {
        var columnsArr = [
          [dataLj[1][0], dataLj[2][0]],
          [dataLj[1][1], dataLj[2][1]],
          [dataLj[1][2], dataLj[2][2]],
          [dataLj[1][3], dataLj[2][3]],
          [dataLj[1][4], dataLj[2][4]],
        ]
      } else {
        var columnsArr = [
          [dataLj[1][0], dataLj[4][0]],
          [dataLj[1][1], dataLj[4][1]],
          [dataLj[1][2], dataLj[4][2]],
          [dataLj[1][3], dataLj[4][3]],
          [dataLj[1][4], dataLj[4][4]],
        ]
      }*/      

      let sumArray = this._.slice(this.categories, 5)
      let sum = this._.sumBy(sumArray,'umsatzLj')
      this.sum = sum

      var greys = ['#878787','#9d9d9c','#b2b2b2','#dadada','#ededed'];
      var colors = ['#003366','#1d71b8','#00a19a','#66aa66','#006633'];
      var mixed = [];

      if(showChart) {
        var pie_chart = c3.generate({
          bindto: "#hatgCustomerChart" + this.mode,
          size: { width: 300, height: 300 },
          color: {
            pattern: colors
          },
          data: {
            columns: columnsArr,
            type : 'pie'
          }
        });
      } else {
        $("#hatgCustomerChart" + this.mode).html('')
      }
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName(type,value) {
      this.$parent.setName(type,value)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// MaincategoryYear.vue?58c31717